import { configureStore } from './configureStore';
const initialState = {};

export const store = configureStore(initialState);
